import { BLE_PERIPHERAL_CONNECTION_STATUS} from './constants'

export type ConnectionStatus = {
  key: typeof BLE_PERIPHERAL_CONNECTION_STATUS[keyof typeof BLE_PERIPHERAL_CONNECTION_STATUS],
  value: string,
  color: string,
  backgroundColor: string
}

/**
 * Bluetooth Connection Status Collection
 */
export default [
  {
    key: BLE_PERIPHERAL_CONNECTION_STATUS.CONNECTED,
    value: 'Connected',
    color: 'success.700',
    backgroundColor: 'success.50',
  },
  {
    key: BLE_PERIPHERAL_CONNECTION_STATUS.DISCONNECTED,
    value: 'Disconnected',
    color: 'error.700',
    backgroundColor: 'error.50',
  },
  {
    key: BLE_PERIPHERAL_CONNECTION_STATUS.CONNECTING,
    value: 'Connecting',
    color: 'warning.700',
    backgroundColor: 'warning.50',
  },
] satisfies ConnectionStatus[]
